// function bundlePopupSlider() {
//   new Swiper("[js-hb-popup-video]", {
//     slidesPerView: "auto",
//     spaceBetween: 24.5,
//     breakpoints: {
//       0: {
//         spaceBetween: 24.5,
//       },
//       768: {
//         spaceBetween: 18,
//       },
//       1024: {
//         spaceBetween: 22.67,
//       },
//     },
//     });
// }
// bundlePopupSlider();
// document.addEventListener('bundlePopupSlider:init', bundlePopupSlider)

function bundlePopupClose () {
  const bundlePopupOverlay =  document.querySelectorAll('[js-hb-popup-cross-icon]')
  const bundlePopupWraper = document.querySelectorAll('[js-hb-bundle-popup-wrap]')

  bundlePopupOverlay.forEach(popupOverlay => {
    popupOverlay.addEventListener('click',()=>{
      bundlePopupWraper.forEach(wrapper=> {
        wrapper.classList.remove('active')
      })
    })
  });
}
bundlePopupClose()
document.addEventListener('bundlePopupClose:init', bundlePopupClose)

function bundlePopupATB() {
  const container = document.querySelector('[js-main-popup]')
  const popupATBBtns = container.querySelector('[js-popup-atb-btn]')
 

  if(popupATBBtns) {
    popupATBBtns.addEventListener('click', function(e) {
      e.preventDefault()
      
      e.stopImmediatePropagation();
      const popupParent = e.target.closest('[js-main-popup]')
      const productId = e.target.dataset.productId

      const bundleContainer = document.querySelector('bundle-builder')
      const atcBtnProductGrid = bundleContainer.querySelector(`[js-product-wrapper][data-product-id='${productId}']`)

     
      if(!atcBtnProductGrid.classList.contains('selected')) {
        if(!atcBtnProductGrid.querySelector('[js-select-product-btn]').classList.contains('disabled')) {
          atcBtnProductGrid.querySelector('[js-select-product-btn]').click()
        }
      } else {
        if(!atcBtnProductGrid.querySelector('[js-quantity-increment]').classList.contains('disabled')) {
          atcBtnProductGrid.querySelector('[js-quantity-increment]').click()
        }
      }
      popupParent.querySelector('[js-hb-popup-cross-icon]').click()
    })
  }
}
bundlePopupATB()
document.addEventListener('bundlePopupATB:init', bundlePopupATB)